import { scaleTime, scaleLinear, extent } from 'd3';
import { USDCurrencyCompactFormatter } from 'Helpers/Formats';

const mapResourceToChartDataPoint = (r) => ({
  x: (new Date(r.attr('date'))).getTime(),
  y: Number(r.attr('value')),
});

const yAxisTickFormatter = (v) => USDCurrencyCompactFormatter.format(v);

export default function useManagedAccountActivitySummaryChart(activitySummary) {
  const usingMockData = !activitySummary;
  const balanceChartData = {
    data: [],
  };
  const contributionChartData = {
    data: [],
  };

  let xAxisArgs = {
    dataKey: 'x',
    type: 'number',
    domain: ['auto', 'auto'],
    ticks: [],
    scale: 'auto',
  };

  let yAxisArgs = {
    dataKey: 'y',
    type: 'number',
    domain: ['auto', 'auto'],
    ticks: [],
    tickFormatter: yAxisTickFormatter,
    scale: 'auto',
  };

  function processActivitySummary() {
    if (!activitySummary) return;

    let allData = [];

    // calculate balance chart data
    if (activitySummary.attr('balanceChartData')) {
      balanceChartData.data = activitySummary.attr('balanceChartData').resources().list()
        .slice()
        .reverse()
        .map(mapResourceToChartDataPoint);

      allData = allData.concat(balanceChartData.data);
    }

    // calculate contributions chart data
    if (activitySummary.attr('contributionChartData')) {
      contributionChartData.data = activitySummary.attr('contributionChartData').resources().list()
        .slice()
        .reverse()
        .map(mapResourceToChartDataPoint);

      allData = allData.concat(contributionChartData.data);
    }

    const timeScale = scaleTime().domain(extent(allData, d => d.x));

    xAxisArgs = {
      ...xAxisArgs,
      domain: timeScale.domain().map(time => time.valueOf()),
      scale: timeScale,
      ticks: timeScale.ticks(5),
      tickFormatter: timeScale.tickFormat(),
    };

    const valueScale = scaleLinear().domain(extent(allData, d => d.y)).nice();
    yAxisArgs = {
      ...yAxisArgs,
      domain: valueScale.domain(),
      scale: valueScale,
      ticks: valueScale.ticks(5),
    };
  }

  processActivitySummary();

  return {
    usingMockData,
    balanceChartData,
    contributionChartData,
    xAxisArgs,
    yAxisArgs,
  };
}
